import { encodeLeadPayload } from '../../helpers';
import { generateFunnelAuthJwt } from '../../utils/funnelAuthJwt';
import { type SiteDetailsRequest, type SiteCalcRequest } from '../types';

const SLF_DEV_API_URL = process.env.REACT_APP_SLF_API_URL_ENPHASE;
const GLOBAL_API_URL = process.env.REACT_APP_GLOBAL_BACKEND_API || '';

const Api = {
  loginToEnlighten: (username: string, password: string) => {
    return fetch(`${SLF_DEV_API_URL}/api/enphase/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        username,
        password,
      }),
    }).then(async (response) => {
      if (response.ok) {
        return await response.json();
      } else {
        const errorMessage = await response.text();
        return Promise.reject(new Error(errorMessage));
      }
    });
  },
  getSiteDetails: (request: SiteDetailsRequest) => {
    const { siteId, token, zipCode } = request;
    return fetch(`${SLF_DEV_API_URL}/api/enphase/get_site_details`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        site_id: siteId,
        token,
        zip: Number(zipCode),
      }),
    }).then(async (response) => {
      if (response.ok) {
        return await response.json();
      } else {
        const errorMessage = await response.text();
        return Promise.reject(new Error(errorMessage));
      }
    });
  },
  getSiteCalculations: (request: SiteCalcRequest) => {
    const { monthlyUsage, siteId, token, zipCode } = request;
    return fetch(`${SLF_DEV_API_URL}/api/enphase/get_site_calc`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        monthly_usage: monthlyUsage,
        site_id: siteId,
        token,
        zip: Number(zipCode),
      }),
    }).then(async (response) => {
      if (response.ok) {
        return await response.json();
      } else {
        const errorMessage = await response.text();
        return Promise.reject(new Error(errorMessage));
      }
    });
  },
  createLead: async (request: any, urlParams: string, testName: string) => {
    const jwt = await generateFunnelAuthJwt();
    return fetch(`${GLOBAL_API_URL}/v1/leads/encode/add`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${jwt}`,
      },
      body: JSON.stringify({ payload: encodeLeadPayload(request) }),
    }).then(async (response) => {
      if (response.ok) {
        const resultText = await response.text();
        let result: any = {};
        try {
          result = JSON.parse(resultText);
        } catch (e) {
          const jsonMatches = resultText.match(/{".+"}/g);
          if (jsonMatches) result = JSON.parse(jsonMatches[0]);
        }
        return result;
      } else {
        const errorMessage = await response.text();
        return Promise.reject(new Error(errorMessage));
      }
    });
  },
};

export default Api;
